module.exports = __webpack_public_path__ + "static/img/cachet.fe1e1ccb.png";